import React from "react";
import { connect } from "react-redux";

function FormTarefaConfig(props) {
    return (
        <div className={'flex mb-3 mr-5 flex-nowrap' + props.clases} >
            <label htmlFor="exampleFormControlInput1" className="form-label mr-3 mt-2">{props.label}</label>
            <input
                className={`form-control 
            ${props.tema === 'escuro' ? "bg-dark text-white" : 'focus:text-black'} ` + props.width}
                placeholder={props.placeholder} value={props.value} onChange={props.onChange} />
        </div>
    )
}

FormTarefaConfig.defaultProps = {
    width: 'w-9/12'
}

const mapStateToProps = (state) => {
    return {
        tema: state.appReducer.tema
    }
}

export default connect(mapStateToProps, null)(FormTarefaConfig)


